<script lang="ts">
	import { Verbiage, t } from '@infinitro/content';
	import {
		SupportChatHelpIcon,
		SupportChatHomeIcon,
		SupportChatMessagesIcon
	} from '@infinitro/icons';
	import type { Tab } from '../types';

	export let activeTab: Tab = 'home';
	export let onSwitchTab: (tab: Tab) => void = () => {};
</script>

<nav class="tabbar" aria-label={$t(Verbiage.support)}>
	<button
		class:tabbar-item-active={activeTab === 'home'}
		class="tabbar-item"
		type="button"
		on:click={() => onSwitchTab('home')}
	>
		<span class="tabbar-icon" aria-hidden="true">
			<SupportChatHomeIcon size={24} />
		</span>
		<span class="tabbar-label">{$t(Verbiage.support_chat_home)}</span>
	</button>

	<button
		class:tabbar-item-active={activeTab === 'messages'}
		class="tabbar-item"
		type="button"
		on:click={() => onSwitchTab('messages')}
	>
		<span class="tabbar-icon" aria-hidden="true">
			<SupportChatMessagesIcon size={24} />
		</span>
		<span class="tabbar-label">{$t(Verbiage.support_chat_messages)}</span>
	</button>

	<button
		class:tabbar-item-active={activeTab === 'help'}
		class="tabbar-item"
		type="button"
		on:click={() => onSwitchTab('help')}
	>
		<span class="tabbar-icon" aria-hidden="true">
			<SupportChatHelpIcon size={24} />
		</span>
		<span class="tabbar-label">{$t(Verbiage.help)}</span>
	</button>
</nav>

<style>
	.tabbar {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		border-top-width: 1px;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
}

	.tabbar-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.25rem;
		border-radius: 16px;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		color: var(--color-text-500);
}

	.tabbar-item-active .tabbar-label {
		display: inline-block;
		background: linear-gradient(
			to top,
			var(--color-secondary-700) 0%,
			var(--color-secondary-500) 100%
		);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
	}

	.tabbar-item-active .tabbar-icon {
		color: var(--color-secondary-500);
	}

	.tabbar-icon {
		display: block;
		height: 24px;
		width: 24px;
}

	.tabbar-label {
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 600;
}

	.tabbar-icon :global(svg),
	.tabbar-icon :global(img) {
		height: 100%;
		width: 100%;
}
</style>
